import { MotifFormField, MotifLabel, MotifOption, MotifSelect } from '@ey-xd/motif-react'
import React from 'react'

const SelectOptions = () => {
    return (
        <MotifFormField>
            <MotifLabel id="select-label">
            Category
  </MotifLabel>
            <MotifSelect
                ariaLabelledBy="select-label"
                onChange={function Xo() { }}
                placeholder="Select"
                value={""}
                visibleOptions={3}
            >
                <MotifOption value="apple">
                    Option 1
                </MotifOption>
                <MotifOption value="apple">
                    Option 2
                </MotifOption>
                <MotifOption value="apple">
                    Option 3
                </MotifOption>
                <MotifOption value="apple">
                    Option 4
                </MotifOption>
            </MotifSelect>
        </MotifFormField>
    )
}

export default SelectOptions